import React from 'react';
import { Box, Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem } from '@mui/material'; // Ajoutez List et ListItem ici
import { keyframes } from '@emotion/react';
import NavigationBar from '../navbar/NavigationBar';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const styles = {
  header: {
    backgroundColor: '#4CAF50', // Vert
    color: 'white',
    padding: '20px',
    textAlign: 'center',
    animation: `${fadeIn} 0.5s ease-in-out`,
  },
  sectionTitle: {
    color: '#D32F2F', // Rouge
    marginBottom: '10px',
  },
  footer: {
    backgroundColor: '#f7f7f7',
    borderTop: '1px solid #e0e0e0',
    padding: '20px',
    textAlign: 'center',
    animation: `${fadeIn} 0.5s ease-in-out`,
  },
  listItem: {
    margin: '10px 0',
  },
  tableContainer: {
    marginTop: '20px',
    animation: `${fadeIn} 0.5s ease-in-out`,
  },
};

function Aao() {
  return (
    <div>
      <NavigationBar />
      <Container>
        <header style={styles.header}>
          <Typography variant="h4">Avis Spécifique d'Appel d'Offres (AAO)</Typography>
          <Typography variant="h6">
            Appel d'Offres No : BI-INSBU-452360-GO-RFB
            <br />
           Projet : Projet Régional de Statistique pour les Résultats de l'Afrique de l'Est <br/>
           Acheteur : Institut National de la Statistique du Burundi (INSBU) <br/>
           Pays : République du Burundi <br/>
           Intitulé du Marché : Acquisition de matériel informatique,BI-INSBU-452360-GO-RFB <br/>
           Prêt/Credit/Don No : P 176371 <br/>
           Émis le : 20/12/2024
          </Typography>
        </header>

        <main>
          <section>
            <Typography variant="h5" style={styles.sectionTitle}>
              Appel d'Offres pour Fourniture de 44 Ordinateurs Portables
            </Typography>
            <Typography paragraph>
              L'Institut National de la Statistique du Burundi (INSBU) sollicite des
              offres fermées de la part de soumissionnaires éligibles et répondant aux
              qualifications requises pour fournir 44 ordinateurs portables.
            </Typography>
            <List>
              <ListItem style={styles.listItem}>
                <strong>Pays : </strong> République du Burundi
              </ListItem>
              <ListItem style={styles.listItem}>
                <strong>Acheteur : </strong> Institut National de la Statistique du Burundi (INSBU)
              </ListItem>
            </List>
          </section>

          <section>
            <Typography variant="h5" style={styles.sectionTitle}>
              Informations de Contact
            </Typography>
            <List>
              <ListItem style={styles.listItem}>
                <strong>Adresse : </strong>
                Zone Rohero, Quartier INSS, Avenue de l'Aviation, Numéro 06, B.P. 1156, Bujumbura
              </ListItem>
              <ListItem style={styles.listItem}>
                <strong>Téléphone : </strong>
                +257 22 22 67 31 / 22 22 21 91 / 22 22 67
              </ListItem>
              <ListItem style={styles.listItem}>
                <strong>Email : </strong>
                <a href="mailto:ins.burundi@insbu.bi">ins.burundi@insbu.bi</a>
              </ListItem>
            </List>
          </section>

          <section>
            <Typography variant="h5" style={styles.sectionTitle}>
              Documents Requis
            </Typography>
            <List>
              <ListItem style={styles.listItem}>
                Le soumissionnaire doit fournir une garantie de soumission d'un montant de 5 000 000 de Francs Burundais (BIF 5 000 000).
              </ListItem>
              <ListItem style={styles.listItem}>
                Le soumissionnaire doit fournir une copie du certificat d'incorporation de l'entreprise.
              </ListItem>
              <ListItem style={styles.listItem}>
                Les soumissionnaires doivent soumettre leurs offres avant la date limite.
              </ListItem>
            </List>
          </section>

          <Box style={styles.tableContainer}>
            <Typography variant="h5" style={styles.sectionTitle}>
              Récapitulatif des Documents
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Document</strong></TableCell>
                    <TableCell><strong>Description</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Garantie de Soumission</TableCell>
                    <TableCell>5 000 000 BIF</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Certificat d'Incorporation</TableCell>
                    <TableCell>Doit être inclus</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Offre</TableCell>
                    <TableCell>À soumettre avant la date limite</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </main>

        <footer style={styles.footer}>
          <Typography variant="body1">
            Dossier d'Appel d'Offres - Fourniture de 44 Ordinateurs Portables
            <br />
            Appel d'Offres No : 111-INSBU-152360-GO-RFB
          </Typography>
          <Typography variant="caption">
            Émis le : 20/12/2024
          </Typography>
        </footer>
      </Container>
    </div>
  );
}

export default Aao;